import React from 'react'
import async from 'async'

import app from '../../../app.jsx'
import PageBase from '../page_base/page_base.jsx'
import FormPersonalSetting from '../../form/form_personal_setting/form_personal_setting.jsx'
import PageHeader from '../../../theme/layout/page_header/page_header.jsx'
import Typo from '../../../common/typography/typo/typo.jsx'
import Acl from '../../../lib/acl.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import { ProfileIcon } from '../../../common/layout/menu_icons/profile.jsx'

class PagePersonalSetting extends PageBase {
  constructor (props) {
    super(props, 'personalsetting', 'user-profile', 'personal-setting')

    this._references = {
      pageHeader: React.createRef()
    }

    this.state = {
      isLoading: true,
      dataDate: null
    }

    this.data = {
      personalSetting: null
    }

    this._bUnMounted = false
  }

  componentDidMount () {
    this._getData()
  }

  renderContent () {
    const { personalSetting } = this.data

    return (
      <div className='pageuser-personalsetting'>
        <div className='colleft'>
          <Typo className='profile'>
            <h2>
              <IntlMessage ident='user.personal.contentTitle' />
            </h2>
            {this.props.showQuickbook ? (
              <div>
                <IntlMessage ident='user.personal.contentInfoAlt' html />
              </div>
            ) : (
              <div>
                <IntlMessage ident='user.personal.contentInfo' />
              </div>
            )}
          </Typo>
        </div>
        <div className='colright'>
          {personalSetting && (
            <FormPersonalSetting
              data={personalSetting || {}}
              onSubmit={this._onFormSubmit.bind(this)}
            />
          )}
        </div>
      </div>
    )
  }

  _reloadData () {
    this._getData()
  }

  getContentClassname () {
    return 'alt'
  }

  /* Private Functions */
  _getData () {
    async.series(
      [
        (done) => {
          this._getPageData(done)
        },
        (done) => {
          this._getDataPersonalSetting(done)
        }
      ],
      (err, _res) => {
        this._onDataReceived(err)
      }
    )
  }

  _onFormSubmit (data) {
    if (app.loggedInUserTeam) {
      app
        .service('/api/page/personalsetting')
        .update(app.loggedInUserTeam.id, data, {})
        .then((settingRes) => {
          app.setPersonalSetting(settingRes)

          if (this._references.pageHeader.current) {
            this._references.pageHeader.current.showSuccess(
              'setting.project.msgSuccessTitle',
              'setting.project.msgSuccessContent'
            )
          }
        })
        .catch((err) => {
          app.debug('PagePersonalSetting: _onFormSubmit err', err)
          if (this._references.pageHeader.current) {
            this._references.pageHeader.current.showError(
              'setting.project.msgSuccessTitle',
              'setting.project.msgSuccessContent'
            )
          }
        })
    }
  }

  _onDataReceived (err) {
    if (this._bUnMounted) return

    if (err) {
      app.debug('PagePersonalSetting: _onDataReceived Error', err)
    } else {
      app.debug('PagePersonalSetting: _onDataReceived [done]')
      this.setState({ isLoading: false, dataDate: new Date() })
    }
  }

  _getDataPersonalSetting (callback) {
    if (app.loggedInUserTeam) {
      app
        .service('/api/page/personalsetting')
        .get(app.loggedInUserTeam.id, {})
        .then((result) => {
          this.data.personalSetting = result
          callback(null)
        })
        .catch((err) => {
          app.debug('PagePersonalSetting: _getDataPersonalSetting err', err)
          callback(err)
        })
    } else {
      app.debug(
        'PagePersonalSetting: _getDataPersonalSetting -- Invalid UserTeam'
      )
    }
  }

  /* Header Functions - START */
  renderHeader () {
    const tabsUser = [
      {
        ident: 'user-profile',
        title: 'user.overview.overview',
        showFavourite: true
      },
      {
        ident: 'user-schedule',
        title: 'user.schedule.schedule',
        showFavourite: true
      },
      {
        ident: 'user-skills',
        title: 'user.skills.skills',
        showFavourite: true
      },
      {
        ident: 'personal-setting',
        title: 'user.personal.settings',
        showFavourite: true
      }
    ]

    const tabs = []

    tabsUser.map((tabitem, _idx) => {
      if (Acl.isPageAllowed(tabitem.ident)) {
        tabs.push(tabitem)
      }
    })

    return (
      <PageHeader
        ref={this._references.pageHeader}
        title='user.profile.title'
        icon={<ProfileIcon width={20} />}
        activeTab='personal-setting'
        favoriteTab={this._getUserFavoriteTab('user') || 'user-profile'}
        tabs={tabs}
        onTabChange={this._onChangePage.bind(this)}
        onToggleFavorite={this._onHeaderToggleFavorite.bind(this)}
      />
    )
  }

  /* Event Handlers */
  _onChangePage (tab) {
    app.changePage(tab.ident)
  }

  _onHeaderToggleFavorite (tab) {
    this._updateUserStateFavorite('user', tab.ident)
    this.setState({ dataDate: new Date() })
  }

  /* Header Functions - END */
}

export default PagePersonalSetting
